export default {
  trends: {
    filters: {
      title: "Filters",
      trends: "Trends",
      allTrends: "All Trends",
      displayGames: "Display Games",
      alternateLines: "Alternate Lines",
    },
    list: {
      empty: {
        noPropsAvailable: "No props available",
        noTrendsAvailableYet: "No trends available yet",
        needsThreeGamesMinimum: "Needs 3 games minimum",
        pendingOddsCheckBack: "Pending odds. Please check back later.",
      },
      preview: {
        comboTrendPreview: "Combo Trend Preview",
        tryLinematePlus: "Try Linemate+",
      },
      actions: {
        addAllLegsToMyPicks: "Add all legs to My Picks",
      },
    },
    cheatsheet: {
      title: "Cheatsheet",
      separator: {
        noLongerHundredPercent: "NO LONGER 100% BELOW THIS",
      },
    },
    details: {
      labels: {
        trendsInThisParlay: "Trends in this parlay",
        straights: "Straights",
        all: "All",
        hitRates: "Hit Rates",
        perGame: "Per Game",
        against: "against",
        rank: "Rank",
        pitcher: "Pitcher",
        handedness: "Handedness",
        defensiveRanking: "Defensive Ranking",
      },
      actions: {
        addAllPicksAsParlay: "Add all picks as parlay",
        removeAll: "Remove all",
      },
    },
  },
};
